import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {currentResource} from '../../../../../../../../../../util/utils';

import EditComponentModal from '../../EditComponentModal';

const InvalidNoPoC = ({item, renderButton}) => {
	const [showModal, setShowModal] = useState(false);

	const engagementId = useSelector(({engagementId}) => engagementId);
	const components = useSelector(({groupAudit}) => groupAudit?.components?.data);
	const scopes = useSelector(({groupAudit}) => groupAudit?.scopes);

	const props = {
		variant: 'text-alt',
		className: 'motif-button',
		showLabel: true,
		buttonLabel: currentResource.groupStructure.edit,
		extraText: currentResource.groupStructure.lowerPoC
	};

	const modalProps = {
		labels: currentResource.groupStructure,
		showModal,
		setShowModal,
		onHideModal: () => setShowModal(false),
		customTrigger: (onClick) => renderButton(currentResource.groupStructure.editPoCTooltip, {...props, onClick}),
		item,
		engagementId,
		components,
		scopes
	};

	return <EditComponentModal {...modalProps} />;
};

export default InvalidNoPoC;
